"use client";

import { useState, type ReactElement } from "react";
import styles from "./AllAvailablePrograms.module.scss";
import { UnivoLink } from "@/components/common";


const IconArrow = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.33337 8H12.6667" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M9 4.33334L12.6667 8.00001L9 11.6667" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

interface ProgramCardData{
  id?: string;
  Title: string;
  Duration?: string;
  Description?: string;
  redirectionUrl?: string;
  Icon?: {
    url:string
  };
}
export interface ProgramCard {
  Slug?: string;
  ProgamCard: ProgramCardData;
}


export default function AllAvailablePrograms({
  heading,
  subtitle,
  programs,
  loadMoreLabel = "Load More",
  isMobile=false
}: {
  heading?: string;
  subtitle?: string;
  programs?: ProgramCard[];
  loadMoreLabel?: string;
  isMobile?: boolean;
}) {
  const [expanded, setExpanded] = useState(false);
  const INITIAL_COUNT =isMobile ? 8: 12;

  if (!programs?.length) return null;

  const visiblePrograms = expanded ? programs : programs.slice(0, INITIAL_COUNT);
  const hasMore = !expanded && programs.length > INITIAL_COUNT;

  return (
    <section className={styles.section}>
      <div className={styles.container}>
        {(heading || subtitle) && (
          <div className={styles.headerBox}>
            {heading && <h2 className={styles.heading}>{heading}</h2>}
            {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
          </div>
        )}

        <div className={styles.gridBox}>
          <div className={styles.grid}>
            {visiblePrograms?.map((program, index) =>{
              const programData=program?.ProgamCard
              return(
              <div key={index} className={styles.card}>
                <div className="flex gap-4">
                  <div className={styles.iconBadge}>
                   <img src={programData?.Icon?.url} />
                  </div>
                  <div>
                    <p className={styles.cardTitle}>{programData?.Title}</p>
                    {programData?.Duration && (
                      <div className={styles.cardDuration}>
                        <span>{programData?.Duration}</span>
                      </div>
                    )}
                  </div>
                </div>

                <div className={styles.cardBody}>
                  {programData?.Description && (
                    <p className={styles.cardDesc}>{programData?.Description}</p>
                  )}
                </div>
                <UnivoLink
                  prefetch={false}
                  id={`link-${index}`}
                  href={program?.Slug }
                  className={styles.viewDetails}
                >
               View Details <IconArrow />
                </UnivoLink>
              </div>)})}
          </div>

          {hasMore && (
            <button
              type="button"
              className={styles.loadMoreBtn}
              onClick={() => setExpanded(true)}
            >
              {loadMoreLabel}
            </button>
          )}
        </div>
      </div>
    </section>
  );
}
